import React from 'react';
import './App.css';
import ChiSiamo from './ChiSiamo';
import Home from './Home';
//import Faq from './Faq'
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Lavoro from './Lavoro';
import N1 from './Profilazione/1';
import N2 from './Profilazione/2';
import N3 from './Profilazione/3';
import N4 from './Profilazione/4';
import N5 from './Profilazione/5';
import N6 from './Profilazione/6';
import HomeProfilazione from './Profilazione/HomeProfilazione';
import Servizi from './Servizi';
import TemplateServizi from './TemplateServizi';
//import StripeForm from './StripeForm';
import LandingComarch from './LandingComarch';
import NoMatch from './NoMatch';
import PrivacyPolicy from './PrivacyPolicy';
import TermCond from './TermCond';

document.apiURL = "https://api.futuracare.it/privato/api/v1"
const App = () => {
	return (
		<>
			<Router basename={'/'}>
				<Switch>
					<Route exact path="/">
						<Home />
					</Route>
					<Route path="/booking/:prof">
						<HomeProfilazione />
					</Route>
					<Route path="/book/1/:bookid">
						<N1 />
					</Route>
					<Route path="/book/2/:bookid">
						<N2 />
					</Route>
					<Route path="/book/3/:bookid">
						<N3 />
					</Route>
					<Route path="/book/4/:bookid">
						<N4 />
					</Route>
					<Route path="/book/5/:bookid">
						<N5 />
					</Route>
					<Route path="/book/6/:bookid">
						<N6 />
					</Route>
					<Route path="/chi-siamo">
						<ChiSiamo />
					</Route>
					<Route path="/servizi">
						<Servizi />
					</Route>
					<Route exact path="/prestazione/telesoccorso-e-teleassistenza">
						<LandingComarch />
					</Route>
					<Route path="/prestazione/:id">
						<TemplateServizi />
					</Route>
					<Route path="/prestazione">
						<Redirect to="/servizi" />
					</Route>
					<Route path="/lavora-con-noi">
						<Lavoro />
					</Route>
					<Route path="/termini">
						<TermCond />
					</Route>
					<Route path="/privacy">
						<PrivacyPolicy />
					</Route>

					<Route path="/bracciale-teleassistenza">
						<LandingComarch />
					</Route>

					<Route path="*" status={404}>

						<NoMatch />
					</Route>
				</Switch>
			</Router>


		</>

	);
}

export default App;
